(function() {
  const intervals = new Map();
  
  // Initialize all synaptic rotators on the page
  function initSynapticRotators() {
    const rotators = document.querySelectorAll('.synaptic-rotator[data-speed]');
    
    rotators.forEach(rotator => {
      // Skip if already initialized
      if (intervals.has(rotator)) return;
      
      const words = rotator.querySelectorAll('.syn-words span');
      if (words.length < 2) return;
      
      let currentIndex = 0;
      const speed = parseInt(rotator.dataset.speed) || 2800;
      
      function rotate() {
        words.forEach((word, index) => {
          word.classList.toggle('is-active', index === currentIndex);
        });
        
        currentIndex = (currentIndex + 1) % words.length;
      }
      
      // Start rotation
      rotate();
      const interval = setInterval(rotate, speed);
      
      // Store interval ID for cleanup
      intervals.set(rotator, interval);
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSynapticRotators);
  } else {
    initSynapticRotators();
  }
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    intervals.forEach(interval => clearInterval(interval));
    intervals.clear();
  });
})();

